
import { deleteCookie } from "../helpers/Storage";
import { combineReducers } from "redux";
import { reducer as forms } from 'redux-form';
import loginReducer from './loginReducer';
import listReducer from './listReducer';

import storageReducer from "./storageReducer";
import optionsReducer from "./optionsReducer";
import layoutReducer from "./layoutReducer";

const appReducer = combineReducers({
    form: forms,
    storage: storageReducer,
    login: loginReducer,
    list: listReducer,
    options: optionsReducer,
    layout: layoutReducer,

})

const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        deleteCookie();
        state = undefined
    }
    return appReducer(state, action)
}

export default rootReducer;